import React, { useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import HeroImg from "./img/hero.webp";
import { Star, FileEarmarkText, JustifyLeft } from "react-bootstrap-icons";
import useGetUrlLocale from "./../../../hooks/useGetUrlLocale";
import { Link } from "react-router-dom";

const ME_PAGE_LINK = process.env.REACT_APP_ME_PAGE_URL;

export default function SuccessfulPayment() {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();

  useEffect(() => {
    document.title = "Successful Payment";
  }, []);

  return (
    <Container
      fluid
      className="gx-0 text-white bg-additional-gray"
      style={{ minHeight: "100vh" }}
    >
      <Container>
        <Row>
          <Col className="me-auto text-center text-lg-start mt-3">
            <a href={`${ME_PAGE_LINK}${lng}`} className="pt-3 mb-5">
              <img src={`${ME_PAGE_LINK}/images/logo.svg`} alt="Logo" />
            </a>
          </Col>
        </Row>

        <div className="bg-primary bg-payment rounded py-5 mt-3 px-3">
          <Row className="gy-5">
            <Col lg={6}>
              <Col xs={8} md={6} lg={12} className="m-auto text-center">
                <img src={HeroImg} alt="Hero" className="img-fluid" />
              </Col>
            </Col>
            <Col lg={6} className="d-lg-flex align-items-center">
              <div className="text-center text-lg-start">
                <h1 className="fw-bold text-white fs-8">
                  {t("payment.Payment Successful!")}
                </h1>
                <div className="mb-5">
                  {t("payment.Start enjoying all the benefits of")}{" "}
                  <span className="fw-bold">
                    {t("payment.ME-Web Premium")}:
                  </span>
                </div>
                <div className="mb-3">
                  <Star className="me-2 mb-1" />
                  {t("payment.Unlimited")}{" "}
                  <Link className="text-white" to={`${lng}/projects`}>
                    {t("payment.Pages")}
                  </Link>{" "}
                  {t("payment.Creation")}
                </div>
                <div className="mb-3">
                  <FileEarmarkText className="me-2 mb-1" />
                  {t("payment.Unlimited")}{" "}
                  <Link className="text-white" to={`${lng}/projects`}>
                    {t("payment.Projects")}
                  </Link>{" "}
                  {t("payment.Creation")}
                </div>
                <div className="mb-5">
                  <JustifyLeft className="me-2 mb-1" />
                  <a href="#" className="text-white">
                    {t("payment.Start Chat")}
                  </a>{" "}
                  {t("payment.with Personal Support Manager")}
                </div>
                <Link to={`${lng}/projects`}>
                  <Button
                    variant="light"
                    className="bg-white text-primary px-5 fw-bold"
                  >
                    {t("payment.My Projects")}
                  </Button>
                </Link>
              </div>
            </Col>
          </Row>
        </div>

        <Row className="g-4 mt-0">
          <Col md={6} xxl={3}>
            <div className="rounded text-dark p-4 bg-me-qr h-100">
              <Col xs={7}>
                <div className="fs-5" style={{ marginBottom: 38 }}>
                  <span className="fw-bold">{t("payment.Earn by")}</span>{" "}
                  {t("payment.Refer a")}
                  <br />
                  {t("payment.Friends")}{" "}
                  <span className="fw-bold">{t("payment.to Join")}</span>
                  <br />
                  <span className="fw-bold" style={{ color: "#9B27AF" }}>
                    {t("payment.ME-QR Premium")}
                  </span>
                </div>
                <Button
                  as="a"
                  href="https://me-qr.com/"
                  className="text-white w-100 border-0"
                  style={{ background: "#9B27AF" }}
                >
                  {t("payment.Join Now!")}
                </Button>
              </Col>
            </div>
          </Col>
          <Col md={6} xxl={3}>
            <div className="rounded text-white p-4 bg-cultural h-100">
              <Col xs={7}>
                <div className="mb-4">
                  <span className="fw-bold">
                    {t("payment.QR Codes for Cultural")}:
                  </span>{" "}
                  <span className="fst-italic" style={{ color: "#EB5647" }}>
                    {t("payment.Free")}
                  </span>
                  <br />
                  <span className="fst-italic">
                    {t("payment.Package of Design Services")}
                  </span>
                </div>
                <Button
                  as="a"
                  href="https://me-qr-museum.com/"
                  className="text-white w-100 border-0"
                  style={{ background: "#EB5647" }}
                >
                  {t("payment.Get Started")}
                </Button>
              </Col>
            </div>
          </Col>
          <Col md={6} xxl={3}>
            <div className="rounded text-dark p-4 bg-individual h-100">
              <Col xs={7}>
                <div className="mb-4">
                  <span className="fw-bold">
                    {t("payment.Individual")}
                    <br />
                    {t("payment.QR-Code")}
                  </span>{" "}
                  {t("payment.with Designers of")}
                  <br />
                  <span className="fst-italic">{t("payment.ME-QR Team")}</span>
                </div>
                <Button
                  as="a"
                  href="https://me-qr.com/art-qr-code"
                  className="text-white w-100 border-0"
                  style={{ background: "#FED201" }}
                >
                  {t("payment.Get Started")}
                </Button>
              </Col>
            </div>
          </Col>
          <Col md={6} xxl={3}>
            <div className="rounded text-dark p-4 bg-event h-100">
              <Col xs={7}>
                <div className="mb-4">
                  <span className="fw-bold">{t("payment.Create")}</span>{" "}
                  {t("payment.an Event,")}
                  <br />
                  <span className="fw-bold">{t("payment.Generate")}</span>{" "}
                  {t("payment.Tickets with")}{" "}
                  <span className="fst-italic">{t("payment.QR Codes &")}</span>
                  <br />
                  <span className="fw-bold">{t("payment.Enjoy")}</span>{" "}
                  {t("payment.Sell-outs")}
                </div>
                <Button
                  as="a"
                  href="https://me-ticket.com/"
                  className="text-white w-100 bg-success border-0"
                >
                  {t("payment.Get Started")}
                </Button>
              </Col>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
